import { useMutation, useQueryClient } from '@tanstack/react-query';
import { pb } from '@/core/api';
import { useToast } from '@/components/ui/toast';

const ALERT_QKS = [['creators'], ['creator']];

function invalidate(qc: ReturnType<typeof useQueryClient>): void {
  ALERT_QKS.forEach((qk) => qc.invalidateQueries({ queryKey: qk }));
}

export function useAlertCreator() {
  const qc = useQueryClient();
  const { toast } = useToast();
  return useMutation({
    mutationFn: (id: string) =>
      pb.send<{ success: boolean }>(`/api/leads/alert/${id}`, {
        method: 'POST',
      }),
    onSuccess: () => {
      invalidate(qc);
      toast('Creador alertado', 'success');
    },
    onError: (err: Error) => toast(err.message || 'Error al alertar', 'error'),
  });
}

export function useAcknowledgeAlert() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) =>
      pb.send<{ success: boolean }>(`/api/leads/ack-alert/${id}`, {
        method: 'POST',
      }),
    onSuccess: () => invalidate(qc),
  });
}
